import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=6f611d69&scoped=true&"
import script from "./btns.vue?vue&type=script&lang=js&"
export * from "./btns.vue?vue&type=script&lang=js&"
import style0 from "./btns.vue?vue&type=style&index=0&id=6f611d69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f611d69",
  null
  
)

export default component.exports